var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8728 16.8752V9.02667C16.8728 8.93959 16.8546 8.85347 16.8194 8.77383C16.7841 8.69419 16.7327 8.62279 16.6682 8.56421L10.4178 2.88178C10.3028 2.77719 10.1528 2.71923 9.99735 2.71924C9.84186 2.71924 9.69196 2.77721 9.57691 2.88181L3.32734 8.56422C3.26292 8.6228 3.21144 8.69419 3.17622 8.77382C3.141 8.85345 3.1228 8.93957 3.1228 9.02664V16.8752",
    stroke: "#626C70",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2478 16.875H18.7478",
    stroke: "#626C70",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8723 16.8745V12.4995C11.8723 12.3338 11.8065 12.1748 11.6893 12.0576C11.572 11.9404 11.4131 11.8745 11.2473 11.8745H8.74731C8.58155 11.8745 8.42258 11.9404 8.30537 12.0576C8.18816 12.1748 8.12231 12.3338 8.12231 12.4995V16.8745",
    stroke: "#626C70",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.e8293590d451243742b642c57d8647d1.svg";
export { ForwardRef as ReactComponent };